import { Component, OnInit } from '@angular/core';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  Company,
  CompanyQuery,
  CompanyService,
  CompanyOfferModel,
  CompanyOfferQuery,
  CompanyOfferService,
} from '@fgb/core';

export interface OfferWithCompany {
  offer: CompanyOfferModel;
  company: Company | undefined;
}

@Component({
  selector: 'fgb-brand-list',
  templateUrl: './brand-list.component.html',
  styleUrls: ['./brand-list.component.scss'],
})
export class BrandListComponent implements OnInit {
  offerItems$: Observable<OfferWithCompany[]>;

  constructor(
    private companyService: CompanyService,
    private companyQuery: CompanyQuery,
    private companyOfferService: CompanyOfferService,
    private companyOfferQuery: CompanyOfferQuery
  ) {}

  ngOnInit() {
    combineLatest([
      this.companyService.fetchAllCompanies(),
      this.companyOfferService.fetchOffers(0, 0),
    ]).subscribe();

    this.offerItems$ = combineLatest([
      this.companyOfferQuery.selectAllOffers(),
      this.companyQuery.selectCompanies(),
    ]).pipe(
      map(([offers, companies]) =>
        offers.map((offer) => ({
          offer,
          company: companies.find((c) => c.CompanyId === offer.CompanyId),
        }))
      )
    );
  }
}
